import { DomainEvent } from 'src/app/core/domain/events/domain_event';

import { Notification } from '../../notification/notification';

export class NotificationEvent extends DomainEvent<Notification> {}

export class NotificationCreated extends NotificationEvent {}

export class NotificationUpdated extends NotificationEvent {}
